class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    let popUp = document.querySelector('.pop-up__promo-gwp');
    this.checkGiftsInCart();
    this.initCollection();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  checkGiftsInCart() {
    let _this = this,
        gift,
        gift_line,
        promo_buyX_getY_gift_line,
        gift_qty,
        gift_count = 0,
        has_gift = false,
        product_with_gift = false,
        has_promo_buyX_getY = false,
        promo_buyX_getY_trigger = false,
        promo_gwp_trigger = false;

    fetch('/cart.json').then(response => response.json())
        .then(cart => {
          cart.items.forEach(function(cartItem, i) {
            var line_number = i + 1;
            if (cartItem.properties && cartItem.properties['_product-type']) {
              if (cartItem.properties['_product-type'] == 'product_with_gift') {
                product_with_gift = true;
              }
              if (cartItem.properties['_product-type'] == 'gift') {
                gift = cartItem;
                gift_line = line_number;
                has_gift = true;
              }
               if (cartItem.properties['_product-type'] == 'gift buyX getY') {
                 promo_buyX_getY_gift_line = line_number;
                 has_promo_buyX_getY = true;
               }
            }


            if (window.promo_buyX_getY && cartItem.product_id == window.promo_buyX_getY.mainProductTrigger) {
              promo_buyX_getY_trigger = true;
            }
          });
          if (window.promo_pwp){
            const promoProducts = window.promo_pwp.productGifts;
            let cart_drawer__promo_pwp =  document.querySelector('.cart-drawer__promo-pwp');
            const promoStart = (new Date(window.promo_pwp.dataStart).getTime()) + (window.promo_pwp.timeZone * 60 * 1000);
            const promoFinish = (new Date(window.promo_pwp.dataEnd).getTime()) + (window.promo_pwp.timeZone * 60 * 1000);
            const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();

            let promo_products_pwp_in_cart_q = 0;
            let promo_products_pwp_in_cart = [];
            let gift_discounted = false;
            let gift_line;
            promoProducts.forEach(function (promoProduct, index){
              cart.items.some(function (item, index){
                if(item.id  == promoProduct){
                  promo_products_pwp_in_cart_q += 1;
                  promo_products_pwp_in_cart.push(promoProduct);
                  gift_line = index + 1;

                  if (item.total_discount == 0) {
                    gift_discounted = false;
                  } else {
                    gift_discounted = true;
                  }
                  return true;
                }
              });
            });
            if (cart_drawer__promo_pwp && promo_products_pwp_in_cart_q != promoProducts.length && promoStart < customer_time && customer_time < promoFinish) {
              promo_products_pwp_in_cart.forEach(function (product){
                cart_drawer__promo_pwp.querySelector('.cart-item[data-product-id="'+ product +'"]').classList.add('hidden');
              });
              cart_drawer__promo_pwp.classList.remove('hidden');
            }
          }
          if (!product_with_gift && !promo_buyX_getY_trigger && has_gift) {
            //_this.updateQuantity(gift_line, 0, document.activeElement.getAttribute('name'));
          }

           if (!promo_buyX_getY_trigger && has_promo_buyX_getY) {
             //_this.updateQuantity(promo_buyX_getY_gift_line, 0, document.activeElement.getAttribute('name'));
           }
        });

  }

  getCartBeforePromo(){
    let _this = this;
    fetch('/cart.json').then(response => response.json())
        .then(cart => { _this.promoGWP(cart) });
  }

  promoGWP(parsedState){
    let _this = this;
    let cartTotal = (parsedState.total_price / 100 ).toFixed(2);
    if(cartTotal < 1){
      sessionStorage.setItem('gwp', '');
      // return
    }

    let cartItems = parsedState.items;
    let popUp = document.querySelector('.pop-up__promo-gwp');
    let popUp_buyXgetY = document.querySelector('.pop-up__promo-buyXgetY');
    let popUp_pwp = document.querySelector('.pop-up__promo-pwp');
    let cart_drawer__promo_pwp =  document.querySelector('.cart-drawer__promo-pwp');
    let cart_drawer__promo_gwp =  document.querySelector('.cart-drawer__promo-gwp');
    let cart_drawer__promo_buyXgetY =  document.querySelector('.cart-drawer__promo-buyXgetY');

    if(popUp){
      const promo_min_sum = popUp.getAttribute('data-min-sum')*1;
      const promoStart = (new Date(popUp.getAttribute('data-start')).getTime()) + (popUp.getAttribute('data-time-zone') * 60 * 1000);
      const promoFinish = (new Date(popUp.getAttribute('data-finish')).getTime()) + (popUp.getAttribute('data-time-zone') * 60 * 1000);
      const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();

      let popUp_time = (promoStart < customer_time && customer_time < promoFinish) ? true : false;
      let popUp_sum = (cartTotal >= promo_min_sum ) ? true : false;
      let gift_in_cart = false;
      let update_cart = false;

      cartItems.forEach(function (item, index){
        if(item.properties && item.properties['_product-type'] == 'gift_promo_gwp'){
          gift_in_cart = index+1;
        }
      });

      if (popUp_time && !gift_in_cart && sessionStorage.getItem('gwp') != 'close') {
        popUp.classList.remove('hidden');
        document.querySelector('body').classList.add('show-pop-up');
        sessionStorage.setItem('gwp', 'open');
      } else if ((!popUp_time || !popUp_sum) && gift_in_cart) {
        update_cart = true;
      } else{
        console.log()
        window.promo-buyXgetY.closePopUp();
        sessionStorage.setItem('gwp', '');
      }

      if (update_cart) {
        this.updateQuantity(gift_in_cart, 0, document.activeElement.getAttribute('name'));
      }
    }
    if(popUp_buyXgetY){
      const promo_trigger_product = popUp_buyXgetY.getAttribute('data-trigger-product');
      const promoStart = (new Date(popUp_buyXgetY.getAttribute('data-start')).getTime()) + (popUp_buyXgetY.getAttribute('data-time-zone') * 60 * 1000);
      const promoFinish = (new Date(popUp_buyXgetY.getAttribute('data-finish')).getTime()) + (popUp_buyXgetY.getAttribute('data-time-zone') * 60 * 1000);
      const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();

      let popUp_time = (promoStart < customer_time && customer_time < promoFinish) ? true : false;
      let gift_in_cart = false;
      let update_cart = false;

      cartItems.forEach(function (item, index){
        if(item.properties && item.properties['_product-type'] == 'gift'){
          gift_in_cart = index+1;
        }
      });

      if (popUp_time && !gift_in_cart && sessionStorage.getItem('gwp') != 'close') {
        popUp_buyXgetY.classList.remove('hidden');
        document.querySelector('body').classList.add('show-pop-up');
        sessionStorage.setItem('gwp', 'open');
      } else if (!popUp_time && gift_in_cart) {
        update_cart = true;
      } else{
        window.promo.closePopUp();
        sessionStorage.setItem('gwp', '');
      }

      if (update_cart) {
        this.updateQuantity(gift_in_cart, 0, document.activeElement.getAttribute('name'));
      }
    }
    if (window.promo_gwp) {
      this.checkoutButtons = document.querySelectorAll('.drawer__footer button');

      const promoStart = (new Date(window.promo_gwp.dataStart).getTime()) + (window.promo_gwp.timeZone * 60 * 1000);
      const promoFinish = (new Date(window.promo_gwp.dataEnd).getTime()) + (window.promo_gwp.timeZone * 60 * 1000);
      const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();
      let exclude_product_price = 0;
      let promo_min_sum = parseInt(window.promo_gwp.priceTrigger);
      let promo_gwp_in_cart = false;
      let gift_discounted = false;
      let gift_line;
      cartItems.forEach(function (item, index){
        if(item.variant_id && item.variant_id == window.promo_gwp.productGift){
          promo_gwp_in_cart = true;
          gift_line = index + 1;

          if (item.total_discount == 0) {
            gift_discounted = false;
          } else {
            gift_discounted = true;
          }
        }

        if(window.promo_gwp.promoExcludeCollection.length > 0){
          window.promo_gwp.promoExcludeCollection.forEach(exclude_product => {
            if(item.product_id == exclude_product){
              exclude_product_price += item.line_price
            }
          })

        }
      });
      let popUp_sum = ((parseInt(cartTotal)- ((exclude_product_price / 100 ).toFixed(2))) >= promo_min_sum );
      if(!popUp_sum){
        sessionStorage.setItem('p_gwp', '');
      }

      let session_gift = sessionStorage.getItem('p_gwp');

      if(session_gift){
        if(session_gift.indexOf(window.promo_gwp.productGift)>-1){
          promo_gwp_in_cart = true;
        }
      }

      if (!promo_gwp_in_cart && popUp_sum && promoStart < customer_time && customer_time < promoFinish) {
        const sections = this.getSectionsToRender().map((section) => section.section);

        const body = JSON.stringify({
          items: [{
            id: window.promo_gwp.productGift,
            quantity: 1,
            properties: {
              '_product-type': 'gift_promo_gwp'
            }
          }],
          sections: sections,
          sections_url: window.location.pathname
        });

        this.checkoutButtons.forEach(function(item, i) {
          item.classList.add('loading');
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
            // .then((response) => response.json())
            .then((response) => {
              fetch('/cart.json').then(response => response.json())
                  .then(cart => { console.log(cart) });
              if (_this.classList.contains('cart-page-template')) {
                window.location.reload();
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              _this.onCartUpdate();
              this.checkoutButtons.forEach(function(item, i) {
                item.classList.remove('loading');
              });
            });
      } else if ((promo_gwp_in_cart && !popUp_sum) || (promo_gwp_in_cart && customer_time < promoStart) || (promo_gwp_in_cart && customer_time > promoFinish)) {
        this.updateQuantity(gift_line, 0, document.activeElement.getAttribute('name'));
      }
    }
    if (window.promo_pwp){
      const promoProducts = window.promo_pwp.productGifts;
      const promoStart = (new Date(window.promo_pwp.dataStart).getTime()) + (window.promo_pwp.timeZone * 60 * 1000);
      const promoFinish = (new Date(window.promo_pwp.dataEnd).getTime()) + (window.promo_pwp.timeZone * 60 * 1000);
      const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();

      let promo_products_pwp_in_cart_q = 0;
      let promo_products_pwp_in_cart = [];
      let gift_discounted = false;
      let gift_line;
      promoProducts.forEach(function (promoProduct, index){
        cartItems.some(function (item, index){
          if(item.id  == promoProduct){
            promo_products_pwp_in_cart_q += 1;
            promo_products_pwp_in_cart.push(promoProduct);
            gift_line = index + 1;

            if (item.total_discount == 0) {
              gift_discounted = false;
            } else {
              gift_discounted = true;
            }
            return true;
          }
        });
      });
      if (cart_drawer__promo_pwp && promo_products_pwp_in_cart_q != promoProducts.length && promoStart < customer_time && customer_time < promoFinish) {
        promo_products_pwp_in_cart.forEach(function (product){
          cart_drawer__promo_pwp.querySelector('.cart-item[data-product-id="'+ product +'"]').classList.add('hidden');
        });
        cart_drawer__promo_pwp.classList.remove('hidden');
      }
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    console.log('updateQuantity');
    console.log(line);
    console.log(quantity);
    this.enableLoading(line);
    document.querySelectorAll('.cart__checkout-button').forEach((button) => button.removeAttribute('disabled', true));
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        let cart_total_price = Number(Shopify.formatMoney(parsedState.total_price, '\{\{amount\}\}'));
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          document.querySelectorAll('.cart__checkout-button').forEach((button) => button.removeAttribute('disabled', true));
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        document.querySelectorAll('.cart__checkout-button').forEach((button) => button.removeAttribute('disabled', true));
        if(document.querySelector('.cart-drawer__collection')){
          this.initCollection();
        }
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        let new_items = document.querySelectorAll('.drawer__cart-items-wrapper .cart-item');
        let gift_price = 0;
        parsedState.items.forEach(function(cartItem) {
          if(cartItem.gift_card){
            gift_price += Number(Shopify.formatMoney(cartItem.final_line_price, '\{\{amount\}\}'));
          }
        });
        cart_total_price = cart_total_price - gift_price;
        if(parsedState.items.length > 0){
          if(new_items.length == 1){
            if(new_items[0].classList.contains('free-product')){
              this.updateQuantity(
                  1,
                  0,
                  document.activeElement.getAttribute('name'),
                  new_items[0].querySelector('.cart-remove-button').getAttribute('data-variant-id')
              );
              return;
            }
          }else if(cart_total_price < window.cartStrings.cartThresholdFreeSample){
            let item = this.querySelector('.cart-item.free-product');
            if(item){
              let item_id = item.getAttribute('data-id');
              this.updateQuantity(
                  item_id,
                  0
              );
              return;
            }
          }
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.getCartBeforePromo();
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
  initCollection(){
    if(document.querySelector('.cart-drawer__collection')){
      this.collection = document.querySelector('.cart-drawer__collection');
      this.createSlider();
      this.collection.querySelector('.cart-drawer__collection-close').addEventListener('click', this.closeCollection.bind(this));
    }
  }
  closeCollection(){
    this.collection.innerHTML = '';
  }
  createSlider(){
    const swiper = new Swiper('.cart-drawer__collection-products', {
      slidesPerView: 2,
      slidesPerGroup: 2,
      speed: 400,
      direction: 'horizontal',
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: '.cart-drawer__collection-buttons .slider-button--next',
        prevEl: '.cart-drawer__collection-buttons .slider-button--prev'
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        }
      }
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
